import { setLineHeightVar, removeCssVar } from '../utils/domHelpers';
import { CSS_VARS } from '../utils/constants';
import { LINE_HEIGHTS } from '../config/settings';

export function applyLineHeight(index) {
  if (index >= 0 && index < LINE_HEIGHTS.length) {
    const val = LINE_HEIGHTS[index].value;
    setLineHeightVar(val || '');
  }
}

export function removeLineHeight() {
  removeCssVar(CSS_VARS.lineHeight);
}
